import { error } from "jquery";

const initialState = {
    config: {},
    offer:{},
    idOptin:undefined,
    idVote:undefined,
    globalScript: {},
    entryCode: {}
};

export default (state=initialState, action) => {
   
    switch (action.type) {
        
        case 'GET_CONFIG_START': {
            return {
                ...state,
                config: {},
            }
        }
        case 'GET_CONFIG_FINISH': {
            return {
                ...state,
                config:action.payload.data
            }
        }

        case 'SUBMIT_START': {
            return {
                ...state,
                idOptin:undefined
            }
        }
        
        case 'SUBMIT_FINISH': {
            return {
                ...state,
                idOptin:action.payload.data.idOptin
            }
        }
        case 'OFFER_START': {
            return {
                ...state,
            }
        }
        
        case 'OFFER_FINISH':{
            return {
                ...state,
                offer:action.payload.data
            }
        }
        
        case 'OFFER_ERROR':{
            console.log('error-offer', action);
            return {
                ...state,
                offer:action.payload.data
            }
        }


        case 'VOTE_START': {
            return {
                ...state,
                idVote:undefined
            }
        }
        
        case 'VOTE_FINISH':{
            return {
                ...state,
                idVote:action.payload.data.idVote
            }
        }

        
        case 'INVENTORY_START':{
            return {
                ...state,
            }
        }
        case 'INVENTORY_FINISH':{
            return {
                ...state
            }
        }

        case 'OPTIN_TO_VOTE_START':{
            return {
                ...state,
            }
        }
        case 'OPTIN_TO_VOTE_FINISH':{
            return {
                ...state
            }
        }
        case 'GET_GLOBAL_SCRIPTS_START':
            return {
                ...state,
                globalScript: {
                    globalScriptFetched: false,
                    globalScriptData: {}
                }
            }
        case 'GET_GLOBAL_SCRIPTS_FINISH':
            console.log("GET_GLOBAL_SCRIPTS_FINISH", action.payload.data);
            return {
                ...state,
                globalScript: {
                    globalScriptFetched: true,
                    globalScriptData: action.payload && action.payload.data
                }
            }
        case 'REDEEM_ENTRY_START':{
            return {
                ...state,
                entryCode: {
                    isRedeemed: false,
                    error: '',
                    loading: true
                }
            }
        }
        case 'REDEEM_ENTRY_FINISH':{
            return {
                ...state,
                entryCode: {
                    isRedeemed: true,
                    error: '',
                    loading: false
                }
            }
        }
        case 'REDEEM_ENTRY_ERROR':
            console.log('redeem-error', action)
            return {
                ...state,
                entryCode: {
                    isRedeemed: false,
                    error: 'Entry code is invalid!',
                    loading: false
                }
            }

        default:
            return state;
    }
}
